<template>
  <router-view />
  <OffcanvasComponent />
  <SplashScreenComponent  v-if="showSplash" @onAnimationFinished="showSplash = false"/>
</template>

<script lang="ts" setup>
import OffcanvasComponent from '@/components/Offcanvas/OffcanvasComponent.vue';
import { onMounted, onUnmounted, ref } from 'vue';
import SplashScreenComponent from './components/SplashScreenComponent.vue';
import useUser from './composables/useUser';
import useWebSocket from './composables/useWebSocket';
import useGeolocation from './composables/useGeolocation';
import webSocketService from './services/WebSocketService';
const { syncUser} = useUser()
const showSplash = ref(false)
const {connectWebSocket, disconnectWebSocket} = useWebSocket(webSocketService)
const { getUserLocation } = useGeolocation()
if(localStorage.getItem('SPLASH_SHOWN') != 'true') {
  showSplash.value = true
}
localStorage.setItem('SPLASH_SHOWN', 'true')
syncUser()


onMounted(() => {
  connectWebSocket()
  // Request geolocation permission on app startup
  getUserLocation()
})

onUnmounted(() => {
  disconnectWebSocket()
})

</script>